module.exports = __webpack_public_path__ + "static/img/klp1260-663-37084rd.4bd0002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1260-663-37084rd.jpg
// module id = bh+k
// module chunks = 0